import { getAccessToken } from '../lib/supabase'
import type { AiMaterial } from '../types'

const apiBase = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')

const authorizedFetch = async (path: string, init: RequestInit) => {
  const token = await getAccessToken()
  const headers = new Headers(init.headers)
  if (token) headers.set('Authorization', `Bearer ${token}`)
  const response = await fetch(`${apiBase}${path}`, { ...init, headers })
  const body = await response.json().catch(() => ({ error: `HTTP ${response.status}` }))
  if (!response.ok) throw new Error(body.error || body.message || `Сервер қатесі: ${response.status}`)
  return body
}

export const transcribeAudio = async (
  file: Blob,
  name: string,
  language: string,
  lessonId: string,
  model: 'gpt-4o-mini-transcribe' | 'gpt-4o-transcribe',
  prompt = '',
) => {
  const form = new FormData()
  form.append('file', file, name)
  form.append('language', language)
  form.append('lesson_id', lessonId)
  form.append('model', model)
  if (prompt) form.append('prompt', prompt)
  return authorizedFetch('/api/transcribe', { method: 'POST', body: form }) as Promise<{ text: string }>
}

export const processText = async (
  text: string,
  action: 'clean' | 'full-summary' | 'short-summary' | 'quiz' | 'flashcards' | 'explain' | 'book-question',
  language = 'kk',
  question = '',
) =>
  authorizedFetch('/api/process-text', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, action, language, question }),
  }) as Promise<AiMaterial>
